import { render } from "./DashboardPage.vue?vue&type=template&id=568c3463&scoped=true&ts=true"
import script from "./DashboardPage.vue?vue&type=script&lang=ts"
export * from "./DashboardPage.vue?vue&type=script&lang=ts"

import "./DashboardPage.vue?vue&type=style&index=0&id=568c3463&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-568c3463"]])

export default __exports__